import { render, staticRenderFns } from "./ru.vue?vue&type=template&id=55e3f916"
import script from "./ru.vue?vue&type=script&lang=js"
export * from "./ru.vue?vue&type=script&lang=js"
import style0 from "./ru.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-cashback/ru.vue
// module id = HTd4
// module chunks = 0